import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "billetage-form container p-15 p-md-40" }
const _hoisted_3 = { class: "fw-bold text-black mb-15 mb-md-25" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_5 = { class: "div row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "div col-md-12" }
const _hoisted_9 = { class: "div row" }
const _hoisted_10 = { class: "col-md-6 mb-3" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-info mt-2"
}
const _hoisted_13 = { class: "mb-0 mt-2" }
const _hoisted_14 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_15 = { class: "col-md-6 mb-3" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "div row" }
const _hoisted_19 = { class: "col-md-6 mb-3" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = {
  key: 0,
  class: "col-md-6 mb-3"
}
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = {
  key: 1,
  class: "col-md-6 mb-3"
}
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = {
  key: 2,
  class: "col-md-6 mb-3"
}
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = {
  key: 3,
  class: "col-md-6 mb-3"
}
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = {
  key: 4,
  class: "col-md-6 mb-3"
}
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_32 = { class: "col-md-6 mb-3" }
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = ["readonly", "onInput", "disabled"]
const _hoisted_35 = { class: "col-md-6 mb-3" }
const _hoisted_36 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 5,
  class: "row"
}
const _hoisted_39 = { class: "div col-md-6 mb-md-12" }
const _hoisted_40 = { class: "div border border-primary mb-5" }
const _hoisted_41 = {
  class: "div row fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_42 = { class: "col-md-5" }
const _hoisted_43 = {
  key: 0,
  class: "fs-5 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_44 = { class: "div px-3" }
const _hoisted_45 = { class: "div row align-items-center" }
const _hoisted_46 = { class: "div col-md-4 px-1" }
const _hoisted_47 = ["onUpdate:modelValue"]
const _hoisted_48 = { class: "div col-md-4 px-1" }
const _hoisted_49 = { class: "div col-md-4 px-1" }
const _hoisted_50 = ["onUpdate:modelValue"]
const _hoisted_51 = { class: "div col-md-6 mb-md-12" }
const _hoisted_52 = { class: "div col-md-7" }
const _hoisted_53 = { class: "h3 fs-4 text-white" }
const _hoisted_54 = { class: "col-md-5" }
const _hoisted_55 = {
  class: "fs-5 text-white",
  style: {"text-align":"end","font-weight":"bold"}
}
const _hoisted_56 = {
  key: 0,
  class: "div px-3"
}
const _hoisted_57 = { class: "div row align-items-center" }
const _hoisted_58 = { class: "div col-md-4 px-1" }
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = { class: "div col-md-4 px-1" }
const _hoisted_61 = { class: "div col-md-4 px-1" }
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_64 = {
  key: 1,
  class: "div px-3 py-4 text-center"
}
const _hoisted_65 = { class: "mb-0 text-muted" }
const _hoisted_66 = { class: "text-warning" }
const _hoisted_67 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_68 = { class: "col-md-2" }
const _hoisted_69 = { class: "form-group mb-2" }
const _hoisted_70 = {
  key: 0,
  class: "text-black mt-2"
}
const _hoisted_71 = { class: "div mb-3 mt-1" }
const _hoisted_72 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (!_ctx.caisseActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createTextVNode(" Aucune caisse active n'est disponible. Veuillez ouvrir une caisse pour effectuer un paiement. ")),
            (_ctx.showCaisseClosedMessage)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary btn-sm mt-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ouvrirCaisse()))
                }, " Ouvrir la caisse "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Form, {
        ref: "billetageForm",
        onSubmit: _ctx.addPaiement,
        "validation-schema": _ctx.paiementSchema,
        class: _normalizeClass({ 'disabled-form': !_ctx.caisseActive })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de paiement ", -1)),
                _createVNode(_component_Field, {
                  name: "datePaiement",
                  type: "date",
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black",
                  disabled: !_ctx.caisseActive
                }, null, 8, ["value", "disabled"]),
                _createVNode(_component_ErrorMessage, {
                  name: "datePaiement",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Commandes non payées "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "commande" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.commandesOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Sélectionner la commande",
                          onChange: _ctx.handleCommandeChange,
                          disabled: !_ctx.caisseActive
                        }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "commande",
                    class: "text-danger"
                  })
                ]),
                (_ctx.selectedCommande)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _cache[12] || (_cache[12] = _createElementVNode("strong", null, "Récapitulatif :", -1)),
                      _createElementVNode("ul", _hoisted_13, [
                        _createElementVNode("li", null, "Montant total de la commande : " + _toDisplayString(_ctx.commandeSelectionnee.montTTC) + " Fcfa", 1),
                        _createElementVNode("li", null, "Montant déjà payé : " + _toDisplayString(_ctx.commandeSelectionnee.montantDejaPaye) + " Fcfa", 1),
                        _createElementVNode("li", null, "Montant restant à payer : " + _toDisplayString(_ctx.commandeSelectionnee.montantRest) + " Fcfa", 1),
                        (_ctx.commandeSelectionnee.statutPaiement === 'Partielle')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_14, " Cette commande a un paiement partiel en cours "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Montant TTC "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "montantTtc",
                      modelValue: _ctx.montantTtc,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.montantTtc) = $event))
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.montantTtc) = $event)),
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le montant",
                          readonly: "",
                          disabled: !_ctx.caisseActive
                        }, null, 8, _hoisted_17), [
                          [_vModelText, _ctx.montantTtc]
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "montantTtc",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Mode de paiement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "modePaiement",
                      value: 1
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: _ctx.modePaiementOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Sélectionner le mode paiement",
                          onChange: _ctx.handleModePaiementChange,
                          disabled: !_ctx.caisseActive
                        }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "modePaiement",
                    class: "text-danger"
                  })
                ]),
                (_ctx.selectedModePaiement === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Numéro de transaction Mobile Money "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "numeroMobileMoney",
                          modelValue: _ctx.numeroMobileMoney,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.numeroMobileMoney) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_vue_tel_input, _mergeProps({
                              placeholder: "Entrer le numéro de téléphone",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              defaultCountry: "BJ",
                              mode: "international",
                              onValidate: _ctx.validate,
                              class: "shadow-none fs-md-15 text-black py-2",
                              disabled: !_ctx.caisseActive
                            }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate", "disabled"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_ctx.numeroMobileMoney && !_ctx.validPhone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Veuillez entrer un numéro correct "))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ErrorMessage, {
                          name: "numeroMobileMoney",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedModePaiement === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Référence "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "refOperation",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la référence du compte",
                          disabled: !_ctx.caisseActive
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "refOperation",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedModePaiement === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Numéro Virement "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "numeroVirement",
                          type: "number",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le numéro de virement",
                          disabled: !_ctx.caisseActive
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "numeroVirement",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedModePaiement === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Numéro de chèque "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "numCheque",
                          type: "number",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le numéro de chèque",
                          disabled: !_ctx.caisseActive
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "numCheque",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selectedModePaiement === 3 || _ctx.selectedModePaiement === 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Banque "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, { name: "banque" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.banqueOptions,
                              searchable: true,
                              "track-by": "value",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              placeholder: "Sélectionner la banque",
                              disabled: !_ctx.caisseActive
                            }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "banque",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Montant Payé "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "montantPaye" }, {
                      default: _withCtx(({ field }) => [
                        _withDirectives(_createElementVNode("input", _mergeProps({
                          type: "number",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.montantPaye) = $event))
                        }, field, {
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le montant payé",
                          readonly: _ctx.selectedModePaiement === 1,
                          onInput: ($event: any) => (field.onInput($event)),
                          disabled: !_ctx.caisseActive
                        }), null, 16, _hoisted_34), [
                          [
                            _vModelText,
                            _ctx.montantPaye,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          name: "montantPaye",
                          class: "text-danger"
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Montant Reste à Payé "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "montantRest" }, {
                      default: _withCtx(({ field }) => [
                        _createElementVNode("input", _mergeProps({ type: "number" }, field, {
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer le montant reste à payé",
                          readonly: "",
                          disabled: !_ctx.caisseActive
                        }), null, 16, _hoisted_37),
                        _createVNode(_component_ErrorMessage, {
                          name: "montantRest",
                          class: "text-danger"
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.selectedModePaiement === 1 && _ctx.caisseActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "div col-md-7" }, [
                              _createElementVNode("h3", { class: "h3 fs-4 text-white" }, "Billetage Paiement")
                            ], -1)),
                            _createElementVNode("div", _hoisted_42, [
                              (_ctx.montantTotalEncaissement)
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_43, _toDisplayString(_ctx.montantTotalEncaissement) + " Fcfa", 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "div row mt-2" }, [
                              _createElementVNode("div", { class: "div col-md-4" }, [
                                _createElementVNode("label", { class: "label fw-semibold" }, "Monnaie")
                              ]),
                              _createElementVNode("div", { class: "div col-md-4" }, [
                                _createElementVNode("label", { class: "label fw-semibold" }, "Quantité")
                              ]),
                              _createElementVNode("div", { class: "div col-md-4" }, [
                                _createElementVNode("label", { class: "label fw-semibold" }, "Montant")
                              ])
                            ], -1)),
                            _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "hr mt-0" }, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageList, (billetage, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "div container-tight m-0 py-1"
                              }, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _withDirectives(_createElementVNode("input", {
                                      name: "monnaie",
                                      "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                      readonly: "",
                                      class: "form-control compact-input",
                                      placeholder: "Monnaie"
                                    }, null, 8, _hoisted_47), [
                                      [_vModelText, billetage.libelle]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(_component_Field, {
                                      name: `billetageList[${index}].qteBillet`,
                                      type: "number",
                                      min: "0",
                                      modelValue: billetage.qteBillet,
                                      "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                      onInput: event => _ctx.handleBilletageInput(event, billetage, 'encaissement'),
                                      onKeypress: _cache[5] || (_cache[5] = ($event: any) => (_ctx.restrictInput($event))),
                                      class: "form-control compact-input",
                                      placeholder: "Qté",
                                      disabled: !_ctx.caisseActive
                                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput", "disabled"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: `billetageList[${index}].qteBillet`,
                                      class: "text-danger compact-error"
                                    }, null, 8, ["name"])
                                  ]),
                                  _createElementVNode("div", _hoisted_49, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                      readonly: "",
                                      placeholder: "Montant",
                                      class: "form-control compact-input"
                                    }, null, 8, _hoisted_50), [
                                      [_vModelText, billetage.montant]
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["div border mb-5", _ctx.montantManquant > 0 ? 'border-indigo-500 bg-indigo-50' : 'border-danger'])
                        }, [
                          _createElementVNode("div", {
                            class: "div row fw-bold py-2",
                            style: _normalizeStyle(_ctx.montantManquant > 0 ? 'background-color: #6366f1; color: white' : 'background-color: #a40a0a')
                          }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("h3", _hoisted_53, _toDisplayString(_ctx.montantManquant > 0 ? 'Montant Manquant' : 'Reliquat à Rendre'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("h3", _hoisted_55, _toDisplayString(_ctx.montantManquant > 0 ? _ctx.montantManquant : _ctx.reliquatCalcule) + " Fcfa ", 1)
                            ])
                          ], 4),
                          (_ctx.montantManquant === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "div row mt-2" }, [
                                  _createElementVNode("div", { class: "div col-md-4" }, [
                                    _createElementVNode("label", { class: "label fw-semibold" }, "Monnaie")
                                  ]),
                                  _createElementVNode("div", { class: "div col-md-4" }, [
                                    _createElementVNode("label", { class: "label fw-semibold" }, "Quantité")
                                  ]),
                                  _createElementVNode("div", { class: "div col-md-4" }, [
                                    _createElementVNode("label", { class: "label fw-semibold" }, "Montant")
                                  ])
                                ], -1)),
                                _cache[26] || (_cache[26] = _createElementVNode("hr", { class: "hr mt-0" }, null, -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageSortieList, (billetage, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "div container-tight m-0 py-1"
                                  }, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("div", _hoisted_58, [
                                        _withDirectives(_createElementVNode("input", {
                                          name: "monnaie",
                                          "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                          readonly: "",
                                          class: "form-control compact-input",
                                          placeholder: "Monnaie"
                                        }, null, 8, _hoisted_59), [
                                          [_vModelText, billetage.libelle]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_60, [
                                        _createVNode(_component_Field, {
                                          name: `billetageList[${index}].qteBillet`,
                                          type: "number",
                                          min: "0",
                                          modelValue: billetage.qteBillet,
                                          "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                          onInput: event => _ctx.handleBilletageInput(event, billetage, 'encaissement'),
                                          onBlur: () => { if (!billetage.qteBillet) billetage.qteBillet = 0 },
                                          onKeypress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.restrictInput($event))),
                                          class: "form-control compact-input",
                                          placeholder: "Qté",
                                          disabled: !_ctx.caisseActive
                                        }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput", "onBlur", "disabled"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: `billetageSortieList[${index}].qteBillet`,
                                          class: "text-danger compact-error"
                                        }, null, 8, ["name"])
                                      ]),
                                      _createElementVNode("div", _hoisted_61, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                          readonly: "",
                                          placeholder: "Montant",
                                          class: "form-control compact-input"
                                        }, null, 8, _hoisted_62), [
                                          [_vModelText, billetage.montant]
                                        ])
                                      ])
                                    ])
                                  ]))
                                }), 128)),
                                (_ctx.montantTotalSortie > _ctx.reliquatCalcule)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, " Le billetage de sortie (" + _toDisplayString(_ctx.montantTotalSortie) + " Fcfa) dépasse le reliquat (" + _toDisplayString(_ctx.reliquatCalcule) + " Fcfa). ", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fa fa-exclamation-triangle fa-3x text-warning mb-3" }, null, -1)),
                                _cache[29] || (_cache[29] = _createElementVNode("p", { class: "mb-2 text-dark fw-bold" }, " Paiement Partiel ", -1)),
                                _createElementVNode("p", _hoisted_65, [
                                  _cache[27] || (_cache[27] = _createTextVNode(" Il manque encore ")),
                                  _createElementVNode("strong", _hoisted_66, _toDisplayString(_ctx.montantManquant) + " Fcfa", 1)
                                ]),
                                _cache[30] || (_cache[30] = _createElementVNode("p", { class: "mb-0 text-muted small mt-2" }, " Le client pourra compléter le paiement plus tard ", -1))
                              ]))
                        ], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.selectedModePaiement === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-md-10" }, null, -1)),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label fw-semibold mb-1 text-start d-block" }, " Reliquat à retourner ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: _normalizeClass(["form-control form-control-sm shadow-none text-start", { 'is-warning': _ctx.reliquatRetourner > 0 }]),
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reliquatRetourner) = $event)),
                          readonly: ""
                        }, null, 2), [
                          [
                            _vModelText,
                            _ctx.reliquatRetourner,
                            void 0,
                            { number: true }
                          ]
                        ]),
                        (_ctx.reliquatRetourner > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, " Reliquat non rendu : " + _toDisplayString(_ctx.reliquatRetourner) + " Fcfa. ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary top-end",
                  disabled: _ctx.montantError || !_ctx.caisseActive
                }, "Envoyer", 8, _hoisted_72),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger mx-1",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelOperation && _ctx.cancelOperation(...args)))
                }, "Annuler")
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "class"])
    ])
  ]))
}